import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const InfoArea = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;

  & > div {
    margin: 0 15px;

    & > span {
      font-size: 14px;
      color: ${({ theme }) => theme.joyRide.colorText};
    }

    & > ul,
    ol {
      list-style: none;
      padding-left: 12px;

      & > li {
        display: flex;
        align-items: baseline;

        & > span {
          font-size: 14px;
          color: ${({ theme }) => theme.joyRide.colorText};
        }

        &:before {
          content: '•';
          font-size: 12px;
          font-weight: bold;
          width: 1em;
          margin-left: -1em;
          flex-shrink: 0;
          color: ${({ theme }) => theme.joyRide.colorText};
        }
      }
    }
  }
`;

export const CloseButton = styled.button`
  background: ${ColorPalette.Transparent};
  color: ${({ theme }) => theme.joyRide.colorText};
  width: 59px;
  height: 24px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
`;

export const Overlay = styled.div`
  background-color: rgba(${ColorPalette.RGB.White}, 0.5);
  position: fixed;
  height: 100vh;
  width: 100vw;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 99;
`;
